
import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  ServiceList: (param) => {   // 服务商
    return GET('/merchant/serviceMerchantRel/queryServiceByMerchantId', param)
  },
  hfbRecharge: (param) => {   // 汇付宝储值
    return POST('/merchant/accountRecharge/hfbRecharge', param)
  },
  SkypeAccount: (param) => {   // 费用管理-充值账户
    return GET('/merchant/custom/queryRechargeInfo', param)
  },
  BalanceDetail: (param) => {   // 费用管理-余额明细
    return GET('/merchant/account/balanceDetails', param)
  },
  FindAccount: (param) => { // 账户列表
    return GET('/merchant/account/findAccountByServiceId', param)
  },
  ApplyReimburse: (param) => {   // 费用管理-余额明细-申请退款按钮列表
    return GET('/merchant/account/accountOrderDetails', param)
  },
  ReimburseBalance: (param) => {   // 费用管理-余额明细-退款
    return POST('/merchant/accountRefund/refundApply', param)
  },
  ExpenseBreakdown: (param) => {   // 费用管理-费用明细列表
    return GET('/merchant/accountBalanceRecord/accountExpenseDetails', param)
  },
  DetailsChargesExport: (param, rsType) => {   // 费用管理-费用明细列表-导出
    return GETPDF('/merchant/accountBalanceRecord/accountExpenseExport', param, rsType);
  },
  RechargeRecords: (param) => {   // 费用管理-充值记录列表
    return GET('/merchant/accountRecharge/queryRechargeListByPage', param)
  },
  getRechargeReceipt: (param) => {//充值管理-获取充值的电子回单
    return GET('/merchant/accountRecharge/merchant/getRechargeReceipt', param)
  },
  RechargeAliPayOpen:(param) => {  // 费用管理 - 支付宝充值
    return POST("/merchant/accountRecharge/ali/recharge", param);
  },
  FilenameLister: (param, rsType) => {   // 费用管理-充值记录列表-列表导出
    return GETPDF('/merchant/accountRecharge/queryRechargeListExport', param, rsType);
  },
  QueryAccounts: (param) => {   // 费用管理-充值记录-获取账户
    return GET('/merchant/serviceMerchantRel/queryAccountsByServiceId', param)
  },
  UploadRecords: (param) => {   // 费用管理-充值记录列表-上传充值记录
    return POST('/merchant/accountRecharge/rechargeSave', param)
  },
  RefundRecords: (param) => {   // 费用管理-退款记录列表
    return GET('/merchant/accountRefund/findRefundBypage', param)
  },
  RefundRecordExport: (param, rsType) => {   // 费用管理-退款记录列表-列表导出
    return GETPDF('/merchant/accountRefund/findRefundExport', param, rsType);
  },
  calculateRechargeAmount: (param) => {   // 费用管理-计算支付金额或充值金额
    return GET('/merchant/accountRecharge/calculateRechargeAmount', param)
  },
  getMerchantRefundInfoById: (param) => {   // 费用管理-查看退款明细
    return GET('/merchant/accountRefund/getMerchantRefundInfoById', param)
  },
  FindCheckedRefundList: (param) => {   // 费用管理-新商户退款记录列表
    return GET('/merchant/accountRefund/findCheckedRefundList', param)
  },
  FindCheckedRefundListExport: (param) => {   // 费用管理-新商户退款记录列表导出
    return GET('/merchant/accountRefund/findCheckedRefundListExport', param)
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/expense-regulate.js